export default "__VITE_ASSET__bjlBmzX7__"